<template>
  <div class="register">
    <!--    <div class="register-first">-->
    <!--      <LogoIcon class="logo-icon" />-->
    <!--      <p class="lets-start-heading">Let's get started</p>-->
    <!--      <div class="input-box">-->
    <!--        <MailIcon class="mail-icon" />-->
    <!--        <input-->
    <!--            type="text"-->
    <!--            placeholder="Please enter your email"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <button class="continue-button">Continue</button>-->
    <!--      <p class="login-text">Already have an account?</p>-->
    <!--      <p class="login-link">Log back in</p>-->
    <!--    </div>-->
    <div class="register-code">
      <LogoIcon class="logo-icon" />
      <span class="lets-start-heading">Check your email</span>
      <span class="description">
        Enter the code we sent to
      </span>
      <span class="user-email-text">
        example@gmail.com
      </span>
      <div class="inputs">
        <input
          v-for="i in 6"
          :key="i"
          v-model="code[i - 1]"
          @input="handleInput($event)"
          @paste="handleInputPaste($event)"
          @keydown="handleInputKeydown($event)"
          @focus="handleInputFocus($event)"
          type="tel"
          maxlength="1"
          pattern="[0-9]"
          placeholder="•"
        />
      </div>
      <button class="continue-button">Continue</button>
      <span class="no-code-text">Didn't receive code?</span>
      <span class="request-again-text">Request again</span>
    </div>
  </div>
</template>
<script>
import LogoIcon from "@/components/AppLogo";
// import MailIcon from "../@/assets/img/svg/mail.svg";
import { M_REGISTER } from "@/graphql";

export default {
  components: {
    // SignupCard
    LogoIcon
    // MailIcon
  },
  data() {
    return {
      code: ["", "", "", "", "", ""],
      error: "",
      agreed: false,
      email: "",
      password: "",
      artist_spotify_url: "",
      artist_facebook_pixel: "",
      coupon: "",
      loading: false,
      contentLeft: [
        {
          id: 1,
          icon: "verified",
          image: "webapp.svg",
          title: "Premium smart links and landing pages",
          description:
            "Say goodbye to generic links by joining the ranks of top artists using <span class='serif'>vibe.to</span> for their music. Get stunning landing pages and smart links that fans love, with zero coding. It’s bad ass, let’s be honest."
        },

        {
          id: 2,
          icon: "code",
          title: "Turn clicks into loyal fans",
          image: "filter.svg",
          description:
            "With our proprietary layered pixel integrations, you can capitalize on high quality data for custom audiences, retargeting, and lookalike campaigns. Unlock segmented traffic by artist, album, and track."
        },

        {
          id: 3,
          icon: "visibility",
          title: "Understand the data behind your audience and campaigns",
          image: "charts.png",
          description:
            "Say goodbye to blind clickthroughs and excel sheets. Know who your fans are, where they're coming from, and their preferred destinations. Use key insights to increase your results and save money."
        },

        {
          id: 4,
          icon: "touch_app",
          title: "Drive fans to the right place",
          image: "accept.svg",
          description:
            "When you run destination campaigns (like to Spotify), not every person clicking has the app installed, so we invented a smart fallback system. We first try opening the app on their phone, and if that doesn’t work then we guide them to alternative streaming options to stream and buy your music."
        }
      ]
    };
  },
  computed: {
    couponValid() {
      return ["ARISTAKE", "LUCIDFAM", "JASSYANG", "JESSYANG"].includes(
        this.coupon
      );
    }
  },
  methods: {
    handleInput(e) {
      const input = e.target;
      const nextInput = input.nextElementSibling;
      if (nextInput && input.value) {
        nextInput.focus();
        if (nextInput.value) {
          nextInput.select();
        }
      }
    },
    handleInputFocus(e) {
      setTimeout(() => {
        e.target.select();
      }, 0);
    },
    handleInputPaste(e) {
      e.preventDefault();
      const inputs = document.querySelectorAll("code-inputs");
      const paste = e.clipboardData.getData("text");
      inputs.forEach((input, i) => {
        input.value = paste[i] || "";
      });
    },
    handleInputKeydown(e) {
      const KEYBOARDS = {
        backspace: 8,
        arrowLeft: 37,
        arrowRight: 39
      };
      switch (e.keyCode) {
        case KEYBOARDS.backspace:
          this.handleBackspace(e);
          break;
        case KEYBOARDS.arrowLeft:
          this.handleArrowLeft(e);
          break;
        case KEYBOARDS.arrowRight:
          this.handleArrowRight(e);
          break;
        default:
      }
    },
    handleBackspace(e) {
      const input = e.target;
      if (input.value) {
        input.value = "";
        return;
      }
      input.previousElementSibling.focus();
    },
    handleArrowLeft(e) {
      const previousInput = e.target.previousElementSibling;
      if (!previousInput) return;
      previousInput.focus();
    },
    handleArrowRight(e) {
      const nextInput = e.target.nextElementSibling;
      if (!nextInput) return;
      nextInput.focus();
    },
    changeCase(field) {
      if (field === "coupon") {
        this.coupon = this.coupon.toUpperCase();
        this.$refs.couponInput.setFieldValue(this.coupon);
      }
      if (field === "email") {
        this.email = this.email.toLowerCase();
        this.$refs.emailInput.setFieldValue(this.email);
      }
    },
    validate() {
      return this.$refs.form.validate().then(res => {
        if (res) this.register();
        return res;
      });
    },
    async register() {
      this.loading = true;
      this.artist_spotify_url = this.artist_spotify_url.split("?")[0];
      var artist_spotify_id = this.artist_spotify_url.replace(
        "https://open.spotify.com/artist/",
        ""
      );
      artist_spotify_id.replace("http://open.spotify.com/artist/", "");
      try {
        const result = await this.$apollo.mutate({
          mutation: M_REGISTER,
          variables: {
            email: this.email,
            password: this.password,
            artist_spotify_id: artist_spotify_id,
            coupon: this.coupon
          }
        });
        console.log(result.data.register);
        this.error = "";
        localStorage.setItem("token", result.data.register.token);
        await this.$store.dispatch("setUser", result.data.register.user);
        await this.$store.dispatch(
          "setArtist",
          result.data.register.user.artists[0]
        );
        this.loading = false;
        if (this.coupon === "LUCIDFAM") {
          await this.$router.push("links");
        } else {
          document.location = "/billing";
        }
      } catch (err) {
        this.loading = false;
        this.error = err.message.replace("GraphQL error: ", "");
        return;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
//@import "../../../assets/scss/custom/abstracts/colors";
//@import "../../../assets/scss/custom/abstracts/fonts";
.register {
  display: flex;
  justify-content: center;
  align-items: center;
  /* BG/type2 */
  background: #24224a;
}
.register-first {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 276px;
  .logo-icon {
    width: 54px;
  }
  .lets-start-heading {
    margin-top: 30px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 37px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .input-box {
    display: flex;
    align-items: center;
    width: 100%;
    /* Purple-dark */
    background: #100e2a;
    border-radius: 10px;
    svg {
      margin-left: 20px;
      path {
        fill: #59588d;
      }
    }
    input {
      margin-right: 20px;
      z-index: 99;
      background: #100e2a;
      flex: 1;
      padding: 12px;
      color: #59588d;
      border: none;
      /* 14/Regular */
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
      &:focus {
        outline: none;
        border: none;
      }
      &::placeholder {
        color: #59588d;
        /* 14/Regular */
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
      }
    }
  }
  .continue-button {
    margin-top: 18px;
    width: 276px;
    height: 42px;
    /* Gradient/type2 */
    background: linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%);
    border: none;
    opacity: 0.5;
    /* Shadow-button */
    box-shadow: 0px 0px 40px rgba(23, 18, 43, 0.45);
    border-radius: 10px;
    /* 16/SemiBold */
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    align-items: center;
    /* White */
    color: #ffffff;
  }
  .login-text {
    margin-top: 118px;
    /* 16/Regular */
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* Text/type0 */
    color: #b1afcd;
  }
  .login-link {
    color: #9c27b0;
    margin-top: 10px;
    /* 14/SemiBold */
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
  }
}
.register-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 276px;
  .logo-icon {
    width: 54px;
  }
  .lets-start-heading {
    margin-top: 30px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 37px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .description {
    margin-top: 30px;
    /* 16/Regular */
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    /* Text/type0 */
    color: #b1afcd;
  }
  .user-email-text {
    margin-top: 6px;
    /* 16/Regular */
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    /* White */
    color: #ffffff;
  }
  .inputs {
    margin-top: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 9px;
    input {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 42px;
      height: 42px;
      border: none;
      /* BG/type1 */
      background: #1b193c;
      border-radius: 10px;
      /* Inside Auto Layout */
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0px 6px;
      text-align: center;
      /* 16/SemiBold */
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      /* Text/type0 */
      color: #b1afcd;
      &::placeholder {
        color: #59588d;
        /* 14/Regular */
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
      }
    }
  }
  .continue-button {
    margin-top: 18px;
    width: 188px;
    height: 42px;
    border: none;
    /* Gradient/type2 */
    background: linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%);
    /* Shadow-button */
    box-shadow: 0px 0px 40px rgba(23, 18, 43, 0.45);
    border-radius: 10px;
    /* 16/SemiBold */
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    align-items: center;
    /* White */
    color: #ffffff;
    &:disabled {
      /* Gradient/type2 */
      background: linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%);
      border: none;
      opacity: 0.5;
      /* Shadow-button */
      box-shadow: 0px 0px 40px rgba(23, 18, 43, 0.45);
      border-radius: 10px;
    }
  }
  .no-code-text {
    margin-top: 30px;
    /* 16/Regular */
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* Text/type0 */
    color: #b1afcd;
  }
  .request-again-text {
    color: #9c27b0;
    margin-top: 10px;
    /* 14/SemiBold */
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
